import { Component } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatNavList } from '@angular/material/list';
import { MatTooltip } from '@angular/material/tooltip';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AdElDirective } from '../../directives/ad-el/ad-el.directive';

/**
 * Ribbon
 *
 * Persistent side navigation ribbon with icon buttons. Shown only when authenticated.
 */
@Component({
  selector: 'ribbon',
  templateUrl: './ribbon.component.html',
  styleUrls: ['./ribbon.component.scss'],
  host: { adComp: '' },
  imports: [
    AdElDirective,
    MatIcon,
    MatIconButton,
    MatNavList,
    MatTooltip,
    RouterLink,
    RouterLinkActive,
  ],
})
export class RibbonComponent {}
